// Whether Rating Management offers Edit on a row. Completed sessions always
// could be edited. Since TCX-916 a franchisor can review from the Pending tab
// before the consultant completes the meeting (or even if they never do), and
// that review shows here, so any row that already has a review is editable
// too. A non-completed row without a review has nothing to edit.
export const canEditReview = (record: {
  status?: string;
  review?: unknown[];
}): boolean =>
  record?.status === 'completed' ||
  (Array.isArray(record?.review) && record.review.length > 0);
